<template>
  <a-modal
    :title="`${delTit}：${projectItemData.projectname}`"
    :visible.sync="isLimitDialogShow"
    :mask-closable="false"
    width="486px"
    class="edit-limit-dialog del-pro-dialog"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    @ok="submitHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="del-dialog-form">
      <div class="del-tip-box">
        <div class="warn-tips-box">
          <i class="icon iconfont icon-tips-info1" />
          <p>{{ $t('message["980"]') }}。</p>
        </div>
      </div>
      <a-form
        ref="editForm"
        :form="form"
        class="demo-form-inline"
        @submit.prevent="submitHandle"
      >
        <a-form-item>
          <a-input
            v-decorator="['confirm', { rules: [
              { required: true, message: '我已了解相关风险并确认删除' }
            ]}]"
            type="text"
            :placeholder="$t('message[1925]')"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapActions } from 'vuex'
import { getStorage } from '@/lib/storage'

export default {
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      labelPosition: 'right',
      editForm: {
        confirm: ''
      }
    }
  },
  computed: {
    tabType () {
      const { type } = this.$route.query
      return type
    },
    delPlaceholder () {
      return this.$t('message["792"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    delTit () {
      return this.$t('message["978"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('organization/org', ['ajaxDelPro', 'fetchProjectList']),
    ...mapActions('organization/orgRealback', ['ajaxDelProRealback']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    submitHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const realbackCid = getStorage('realbackCid')
          const cid = this.projectItemData.cid
          const formDatas = Object.assign(values, {
            cid: this.tabType === 'realback' ? realbackCid : cid,
            projectid: this.projectItemData.projectid
          })

          let chain = null
          if (this.tabType === 'realback') {
            formDatas.cid2 = cid
            chain = await this.ajaxDelProRealback(formDatas)
            chain
              .setForm(this.form)
              .onSuccess(async () => {
                const chain2 = await this.fetchProjectList({ cid: this.projectItemData.cid })
                chain2.fetch()
              })
          } else {
            formDatas.pType = this.tabType === 'member' ? 2 : 1
            chain = await this.ajaxDelPro({ cid: this.projectItemData.cid })
            chain
              .params(formDatas)
              .setForm(this.form)
              .fetch()
          }
          this.form.resetFields()
          this.isLimitDialogShow = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .del-tip-box {
    background: #ffeaea;
    padding: 8px 24px;
    line-height: 24px;
    color: #f57676;
    margin: -24px;
  }

  .del-dialog-form::v-deep  {
    .ant-form-item-control-wrapper {
      margin-left: 55px;
      margin-top: 49px;
    }
  }
</style>
